import React from "react";
import classes from "./styles.module.scss";
import PageLogo from "../../assets/images/image 967.png";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import ButtonSecondary from "../buttonSecondary";
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

import {  useSelector } from "react-redux";
const sessionYear = process.env.REACT_APP_YEAR;
const Header = (props) => {
    const navigate = useNavigate();
    const role = useSelector(state=>state?.Auth);
    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    }
    return (
        <div className={classes.header_container}>
            <div className={classes.header_content}>
                <Link to={"/"}>
                    <div className={classes.left_section}>
                        <img src={PageLogo} alt="logo" />
                        <div className={classes.brand_text}>
                            <p className={classes.big}>Students Registration</p>
                            <p className={classes.small}>{sessionYear}</p>
                        </div>
                    </div>
                </Link>

                <div className={classes.right_section}>
                    <div className={classes.text_content}>
                        <p className={classes.big}>{props.header_text}</p>
                        <p className={classes.small}>{props.sub_text}</p>
                    </div>


                   
                    {
                        role?.auth?.role==="student" &&  <ButtonSecondary
                        onClick={handleLogout}
                        button_text="Logout"
                        variant="variantOne"
                        icon_two={<LogoutRoundedIcon />}
                        second_className={classes.logout_button}
                    />
                    }
                   
                   
                </div>
            </div>
        </div>
    )
}

Header.propTypes = {
    header_text: PropTypes.string.isRequired,
    sub_text: PropTypes.string.isRequired
};

export default Header;